import { useEffect } from "react";

// Layer FINALE autorevole dei metadata social dinamici: aggiorna in place i tag OG/Twitter
// (nessun duplicato) dopo l'esecuzione della SPA e ripristina i generici YouPAM al dismount.
export function useSocialMeta(meta) {
  const title = meta?.title;
  const description = meta?.description;
  const image = meta?.image;
  const type = meta?.type;
  const card = meta?.card;
  useEffect(() => {
    if (!title) return;
    const origin = window.location.origin;
    const abs = (u) => !u ? `${origin}/og-default.png`
      : (u.startsWith("http") ? u : `${origin}${u.startsWith("/") ? "" : "/"}${u}`);
    const imgBase = abs(image);
    const imgMime = (/\.png($|\?)/i.test(imgBase) || imgBase.includes("og-default")) ? "image/png" : "image/jpeg";
    // Cache-busting stabile: hash dell'identità immagine (l'id cambia quando cambia l'immagine → nuova risorsa per i crawler)
    const hashStr = (s) => { let h = 0x811c9dc5; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = (h * 0x01000193) >>> 0; } return h.toString(16).padStart(8, "0"); };
    const imgAbs = imgBase + (imgBase.includes("?") ? "&" : "?") + "v=" + hashStr(imgBase);
    // og:url = URL pubblica realmente visitata (su /p/{slug} e /p/evento-{id} resta /p/..., coerente col canonical)
    const pageUrl = origin + window.location.pathname;
    const twCard = card || "summary";
    const ogType = type || "profile";

    let live = true;
    const ops = [];
    const set = (selector, attrName, attrVal, value) => {
      if (!live) return;
      let el = document.head.querySelector(selector);
      const created = !el;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attrName, attrVal); document.head.appendChild(el); }
      const prev = el.getAttribute("content");
      el.setAttribute("content", value);
      ops.push({ el, prev, created });
    };
    const p = (prop, value) => set(`meta[property='${prop}']`, "property", prop, value);
    const n = (name, value) => set(`meta[name='${name}']`, "name", name, value);

    p("og:title", title);
    p("og:description", description);
    p("og:image", imgAbs);
    p("og:image:secure_url", imgAbs);
    p("og:image:type", imgMime);
    p("og:image:alt", title);
    p("og:url", pageUrl);
    p("og:type", ogType);
    n("twitter:card", twCard);
    n("twitter:title", title);
    n("twitter:description", description);
    n("twitter:image", imgAbs);
    n("description", description);

    // Dimensioni reali dell'immagine (il prerender attende la rete prima dello snapshot)
    const probe = new window.Image();
    const applyDims = () => {
      if (probe.naturalWidth && probe.naturalHeight) {
        p("og:image:width", String(probe.naturalWidth));
        p("og:image:height", String(probe.naturalHeight));
      }
    };
    probe.onload = applyDims;
    probe.src = imgAbs;
    if (probe.complete) applyDims();

    return () => {
      live = false;
      probe.onload = null;
      for (const op of ops) {
        if (op.created) op.el.remove();
        else if (op.prev !== null) op.el.setAttribute("content", op.prev);
      }
    };
  }, [title, description, image, type, card]);
}
